export default function dateToUtc(date: Date | null): Date | null {
  let newDate = null;
  if (date) {
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000)
  }
  return newDate;
};
